import TosAcceptancePage from '@/components/legal/TosAcceptancePage.tsx';

export const Route = createFileRoute({
	component: TosAcceptancePage,
});
